import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Checkbox from '@material-ui/core/Checkbox'
import { bindActionCreators } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons'
import IconButton from '@material-ui/core/IconButton'

import { TableHead, TableTitle } from '../../common'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as Constants from '../../../helpers/Constants'
import * as laundryActions from '../../actions/Laundries'

const ROWS = [
  {
    id: 'name',
    label: Strings.default.NAME,
    numeric: false,
    sortType: 'string'
  },
  {
    id: 'functioning',
    label: Strings.default.OUT_OF_ORDER,
    numeric: false,
    sortType: 'boolean'
  }
]

class LaundryTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    orderBy: 'name',
    order: 'asc',
    sortType: 'string'
  }

  desc(a, b, orderBy, sortType) {
    if (sortType === 'integer') {
      return b[orderBy] - a[orderBy]
    }

    if (sortType === 'boolean') {
      if (a[orderBy] && !b[orderBy]) {
        return 1
      } else if (!a[orderBy] && b[orderBy]) {
        return -1
      }

      return 0
    }

    if (b[orderBy] < a[orderBy]) {
      return -1
    } else if (b[orderBy] > a[orderBy]) {
      return 1
    }

    return 0
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index])

    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0])

      if (order !== 0) {
        return order
      }

      return a[1] - b[1]
    })

    return stabilizedThis.map(el => el[0])
  }

  getSorting(order, orderBy, sortType) {
    return order === 'desc'
      ? (a, b) => this.desc(a, b, orderBy, sortType)
      : (a, b) => -this.desc(a, b, orderBy, sortType)
  }

  render() {
    const { classes, data, user } = this.props
    const { page, rowsPerPage, orderBy, order, sortType } = this.state
    const startIndex = page * rowsPerPage
    const laundries = data.laundrySystem.laundries
    const laundryType = data.laundrySystem.laundryRule.laundryType

    return (
      <div>
        <Paper className={classes.root}>
          <TableTitle
            iconLabel={Strings.default.NEW_LAUNDRY[laundryType]}
            classes={classes}
            onIconClick={() => this.props.showCreateLaundryModal()}
            header={Strings.default.MANANGE_LAUNDRY[laundryType]}
          />
          <Table className={classes.table} aria-labelledby="tableTitle">
            <TableHead
              rows={ROWS}
              order={order}
              orderBy={orderBy}
              sortOn={(newOrderBy, newOrder, newSortType) =>
                this.setState({
                  orderBy: newOrderBy,
                  order: newOrder,
                  sortType: newSortType
                })
              }
            />
            <TableBody>
              {this.stableSort(
                laundries,
                this.getSorting(order, orderBy, sortType)
              )
                .slice(startIndex, rowsPerPage + startIndex)
                .map(laundry => {
                  return (
                    <TableRow key={laundry.id} className={classes.row}>
                      <TableCell>{laundry.name}</TableCell>
                      <TableCell>
                        <Checkbox disabled checked={!laundry.functioning} />
                      </TableCell>
                      <TableCell numeric>
                        <IconButton
                          aria-label={'Ändra'}
                          onClick={() =>
                            this.props.showEditLaundryModal(laundry)
                          }
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            color={'#3B424D'}
                            style={{ fontSize: 16 }}
                          />
                        </IconButton>
                        <IconButton
                          aria-label={'Ta bort'}
                          onClick={() => {
                            this.props.showAlert(
                              Strings.default.DELETE_LAUNDRY[laundryType],
                              Strings.default.DELETE_LAUNDRY_INFO[laundryType],
                              Constants.TWO_BUTTONS,
                              {
                                title: Strings.default.NO,
                                onPress: () => {}
                              },
                              {
                                title: Strings.default.YES,
                                onPress: () =>
                                  this.props.tryDeleteLaundry(
                                    user.token,
                                    data.community.id,
                                    laundry.id
                                  )
                              }
                            )
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            color={'#e57373'}
                            style={{ fontSize: 16 }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
          <TablePagination
            component={'div'}
            count={laundries.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            labelRowsPerPage={'Rader per sida:'}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} av ${count}`
            }
            onChangePage={(event, page) => this.setState({ page })}
            onChangeRowsPerPage={event =>
              this.setState({ rowsPerPage: event.target.value })
            }
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
          />
        </Paper>
      </div>
    )
  }
}

const Styles = {
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  },
  spacer: {
    flex: '1 1 100%'
  }
}

LaundryTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...laundryActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(LaundryTable)



// WEBPACK FOOTER //
// ./src/components/containers/LaundryTable/index.js